import React from "react";
import { typographyVariants, WPTypography } from "../../packages/WPTypography";
import ToggleSwitch from "../../common/styles/components/switches/CustomSwitch";

import SliderCard from "../SliderCard/SliderCard";
import { useTranslation } from "react-i18next";
import "./SliderCardRecommended.scss";

const SliderCardRecommended = ({
  id = "slider",
  recommendedLabel,
  recommendedValue,
  isToggle,
  onToggleChange,
  disabled = false,
  isInteger = false,
  slider = [],
  subLabel,
}) => {
  const { t } = useTranslation();
  const isSliderContainsMultipleItems = slider.length > 1;
  return (
    <div className="recommended-slider-card">
      <div className="recommended-slider-card-header">
        <div className="recommended-label-group">
          <WPTypography variant="caption" className="recommended-label">
            {recommendedLabel}
          </WPTypography>
          {recommendedValue != null && (
            <WPTypography
              variant={typographyVariants.tableData}
              className="recommended-below-value"
            >
              {`${t("advanceSettings.sliderLabelMiddle")}: ${isInteger ? Math.round(recommendedValue) : recommendedValue}`}
            </WPTypography>
          )}
        </div>
        <ToggleSwitch
          id={id}
          checked={isToggle}
          onChange={onToggleChange}
          small
          className="recommended-toggle"
        />
      </div>
      <div className={`${isSliderContainsMultipleItems?'recommended-box-container':''}`}>
        {subLabel && <div className="recommended-sub-label">{subLabel}</div>}

        {slider.map((item, index) => (
          <div className="slider-card-container">
            <SliderCard
              key={`${item.settingsKey}-${item.resetKey}`}
              id={item.settingsKey}
              min={item.minValue}
              max={item.maxValue}
              label={item.label ?? t(`advanceSettings.${item.labelKey}`)}
              isInteger={item.isInteger}
              inputValue={item.inputValue ?? ""}
              recommended={item.recommended ?? null}
              showCheckbox={item.showCheckbox ?? false}
              checked={item.checked ?? false}
              onCheckChange={item.onCheckChange}
              onChange={item.onChange}
              disabled={item.disabled ?? false}
              checkboxDisabled={item.checkboxDisabled ?? false}
              showDivider={index < slider.length - 1}
              leftLabel={item.leftLabel}
              rightLabel={item.rightLabel}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderCardRecommended;
